<template>
  <div class="main-modal">
    <el-dialog
      :visible.sync="dialogVisible"
      width="1200px"
      :show-close="false"
      :before-close="handleClose"
    >
      <div class="work-info">
        <div class="thumbnail">
          <img
            :src="'resrun-paas/file/downloadFileStream/' + work.certImageId"
            alt=""
            width="680px"
          />
        </div>
        <div class="work-desc">
          <p class="desc-title">
            <span>{{ work.worksName}}</span>
          </p>
          <div class="desc-line"></div>
          <div class="desc-item">
            <div class="item-name">证书编号：</div>
            <div class="item-value">{{ work.copyrightRegisterAuthCertNo }}</div>
          </div>

          <div class="desc-item">
            <div class="item-name">著作权人：</div>
            <div class="item-value">{{ work.owners }}</div>
          </div>
          <div class="desc-item">
            <div class="item-name">作品类型：</div>
            <div class="item-value">{{ work.worksType }}</div>
          </div>
          <div class="desc-item">
            <div class="item-name">公开发表时间：</div>
            <div class="item-value">{{ work.createTime }}</div>
          </div>
          <div class="desc-item">
            <div class="item-name">证明效力状态：</div>
            <div class="item-value">公示中</div>
          </div>
          <div class="desc-item">
            <div class="item-name">作品说明：</div>
            <div class="item-value">{{ work.worksContent }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCopyrightRegisterCers } from "@/api/business";
export default {
  name: "Download",
  data() {
    return {
      dialogVisible: false,
      work: {},
    };
  },
  mounted() {},
  methods: {
    showDialog(work) {
      this.dialogVisible = true;
      this.work = work;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleDownload() {},
  },
  computed: {},
  watch: {},
};
</script>

<style lang="less" scoped>
.work-info {
  height: 600px;
  width: 100%;
  display: flex;
  background-image: url("@/assets/images/announcement-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px;

  .thumbnail {
    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid #999;
    width: 700px;
    align-items: center;
  }
  .work-desc {
    position: relative;
    font-size: 14px;
    padding: 0px 20px;
    box-sizing: border-box;
    flex: 1;

    .desc-title {
      font-size: 16px;
      font-weight: 600;
      width: 100%;
    }
    .desc-line {
      width: 100%;
      position: relative;
      height: 20px;
    }
    .desc-line::after {
      content: "";
      height: 1px;
      width: 100%;
      position: absolute;
      left: 0;
      top: 10px;
      background-color: #666;
    }

    .desc-item {
       

      display: flex;
      padding: 10px 0;
 

      .item-name {
        width: 100px;
      }
      .item-value {
        width: 300px;
      }
    }
  }
}


</style>
<style>
.main-modal .el-dialog__header,.el-dialog__footer{
    display: none;
}
.main-modal .el-dialog__body{
    padding: 0 !important;
}
</style>
